// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTradingSystemRemoveMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADING_SYSTEM_REMOVE_MESSAGE);
        this.ID = null; // TradingSystemIDs
    }
}
